import { apiFetch } from './httpClient';
import { normalizeIdentityPayload } from './identityFromApi';
import {
    clearAuthCache,
    Identity,
    setAccessToken,
    setIdentityCached,
} from './tokenStorage';

export async function login(username: string, password: string) {
    const res = await apiFetch(
        '/api/auth/login',
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password }),
        },
        { auth: false, retryOn401: false }
    );

    if (!res.ok) {
        clearAuthCache();
        throw new Error('Invalid credentials');
    }

    const data = (await res.json()) as {
        accessToken: string;
        identity?: Identity;
        /** Some API stacks serialize nested DTO with PascalCase */
        Identity?: Identity;
    };

    if (!data?.accessToken) {
        clearAuthCache();
        throw new Error('Invalid login response');
    }

    setAccessToken(data.accessToken);
    const identity = normalizeIdentityPayload(data.identity ?? data.Identity);
    if (identity) setIdentityCached(identity);
}

export async function logout() {
    try {
        await apiFetch(
            '/api/auth/logout',
            { method: 'POST' },
            { auth: true, retryOn401: false }
        );
    } finally {
        clearAuthCache();
    }
}

export async function getMe(): Promise<Identity> {
    const res = await apiFetch('/api/auth/me', { method: 'GET' }, { auth: true });
    if (!res.ok) {
        clearAuthCache();
        throw new Error('Not authenticated');
    }
    const raw = await res.json();
    const me = normalizeIdentityPayload(raw);
    if (!me?.id) throw new Error('Not authenticated');
    return me;
}
